import { ErrorBoundary } from '@sentry/react';
import { StackedGrow, Typography } from '@statsbomb/kitbag-components';
import { ReactNode, Suspense } from 'react';
import { twMerge } from 'tailwind-merge';
import { GeneralFallback } from '@/components/contentState/GeneralFallback';
import { MobileMetricDropdown } from './MobileMetricDropdown';

export const MainContent = ({
  children,
  title,
  description,
  className,
}: {
  children: ReactNode;
  title?: string;
  description?: string;
  className?: string;
}) => (
  <div className={twMerge('flex flex-col flex-1 overflow-y-auto', className)}>
    <MobileMetricDropdown />
    {(title || description) && (
      <header className="flex flex-col p-4 gap-1 sticky top-0 z-[1] bg-canvas-tertiary-main">
        {title && <Typography variant="headingMedium">{title}</Typography>}
        {description && (
          <Typography variant="bodyMedium" muted>
            {description}
          </Typography>
        )}
      </header>
    )}
    <StackedGrow>
      <ErrorBoundary fallback={<GeneralFallback type="error" />}>
        <Suspense fallback={<GeneralFallback type="loading" />}>{children}</Suspense>
      </ErrorBoundary>
    </StackedGrow>
  </div>
);
